import { GlobalStyles, Theme } from "@mui/material";
import { StyleFunction } from "../OutletStyles";

const styles: StyleFunction = (theme: Theme) => ({});

const DailiesStyles = () => <GlobalStyles styles={styles} />;

export default DailiesStyles;
